<template>
  <div class="tw:bg-white tw:p-4 tw:rounded-lg tw:shadow-lg tw:flex tw:flex-col tw:gap-4">
    <div class="tw:text-sm tw:text-gray-800 tw:bg-orange-200 tw:rounded-lg tw:px-5 tw:py-4">
      <p
        class="notification tw:inline tw:mr-1"
        v-html="
          $t('rc_fop_expiring_info', {
            ExpirationDate: formatDate(expirationDate),
          })
        "
      />
    </div>

    <div class="tw:flex tw:flex-col tw:gap-1">
      <p class="tw:text-lg tw:font-bold">{{ $t('payment_method_confirm_header') }}</p>
      <p class="tw:text-xs">{{ $t('rc_fop_subtext') }}</p>
    </div>
    <div v-if="defaultPaymentMethod?.type === 'CREDIT_CARD'" class="tw:flex tw:gap-x-2 tw:flex-wrap">
      <div>
        <img
          :src="getCreditCardLogoUrl(defaultPaymentMethod.creditCardType)"
          alt="Credit card logo"
          height="24"
          width="38"
          class="shadow-[0_0_1px_0_rgba(41,52,58,0.75)] tw:mr-2 tw:inline"
        />
        <span>{{ defaultPaymentMethod.cardNumber }}</span>
      </div>
    </div>
    <div class="tw:w-full tw:h-[1px] tw:border-b tw:border-gray-500" />
    <SecondaryButton
      data-testid="rc-payment-update-cta"
      size="medium"
      class="tw:w-full"
      @click="openPaymentPageSoonExpired"
      >{{ `+ ${$t('payment_method_new_cta')}` }}</SecondaryButton
    >
  </div>
</template>
<script setup>
import SecondaryButton from '@/components/base/buttons/SecondaryButton.vue'

import { useFormatting } from '@/composables/useFormatting'

const { formatDate } = useFormatting()

const emit = defineEmits(['openPaymentPageSoonExpired'])
const openPaymentPageSoonExpired = () => emit('openPaymentPageSoonExpired', 'card_to_expire')
const visaLogo = new URL('/src/assets/img/settings-payment/visa.png', import.meta.url)
const mastercardLogo = new URL('/src/assets/img/settings-payment/mastercard.png', import.meta.url)
const americanexpressLogo = new URL('/src/assets/img/settings-payment/americanexpress.png', import.meta.url)

const getCreditCardLogoUrl = type => {
  if (type === 'Visa') return visaLogo
  if (type === 'MasterCard') return mastercardLogo
  if (type === 'AmericanExpress') return americanexpressLogo
}

defineProps({
  type: String,
  defaultPaymentMethod: Object,
  expirationDate: Date,
})
</script>
<style scoped>
.notification :deep(span) {
  font-weight: bold;
}
</style>
